export default __webpack_public_path__ + "static/media/Version (5) - Deathly Hallows_07.4abe05db.jpg";